<script setup lang="ts">
const slots = defineSlots<{
  body(props: object): any;
}>();
</script>

<template>
  <div class="shadow-menu-s absolute z-[1001] flex !w-auto flex-col overflow-hidden rounded-8 bg-white dark:bg-gray-900">
    <slot name="body"></slot>
  </div>
</template>
